export default {
  SERVICE_URL: '/tla/search-engine-frontend/secure/jas',
  autonomy: '/autonomy-marshaller/jas/results',
  stats: '/uws/statistics/jas',
  solr: '/uws/search/service/jas'
};



// WEBPACK FOOTER //
// ./src/search-interface/shared/constants/urls.js